<template>
    <div class="ui-accordion-item">
        <div class="ui-accordion-item__header" @click="toggle">
            <span>{{ title }}</span>

            <img
                v-svg-inline
                src="@/assets/icons/arrow.svg"
                class="ui-accordion-item__icon"
                :class="{ 'ui-accordion-item__icon--rotated': isOpen }"
            />
        </div>

        <transition name="ui-fade">
            <div v-show="isOpen" class="ui-accordion-item__content">
                <slot name="content">{{ content }}</slot>
            </div>
        </transition>
    </div>
</template>

<script lang="ts" setup>
    import { ref, defineProps } from 'vue';

    defineProps<{
        title: string,
        content?: string,
    }>();

    const isOpen = ref(false);

    function toggle(): void {
        isOpen.value = !isOpen.value;
    }
</script>

<style lang="scss" scoped>
    @use './UIAccordionItem.scss' as *;
</style>
